import BaseApi from './BaseApi'

class LoginApi {
  static checkIfAlreadyLogin() {
    return BaseApi.get('login', [])
  };
  static getUserContext() {
    return new Promise((resolve, reject) => {
      BaseApi.get('login/context', [])
        .then((response) => {
          var menuList = [];
          response.menus.forEach((item) => {
            menuList.addDistinct(item, ['groupMenu1', 'menuCode']);
          });
          response.menus = menuList;
          window.jng.userContext = response
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        });
      })
  };

  static login(data) {
    return BaseApi.post('login', data)
  }
  static logout() {
    return BaseApi.delete('login', [])
  };

  static sendToken(email) {
    return BaseApi.delete('password/', [btoa(email)])
  }

  static changeCurrentLanguage(langId) {
    return BaseApi.post('/login/change-current-language'.concatUrl(langId))
  }
  static changePassword(newPwd, onSuccess){
    return BaseApi.post('password/'+newPwd,[], onSuccess);
  }

  static loginUsingEmail(data){
    return BaseApi.post('/user-ext/login-by-email', data)
  }
}

export default LoginApi
